import { render } from "./TabBottom.vue?vue&type=template&id=7e0b00e5"
import script from "./TabBottom.vue?vue&type=script&lang=js"
export * from "./TabBottom.vue?vue&type=script&lang=js"
script.render = render

export default script